import gql from 'graphql-tag';

export const CREATE_REQUEST_GROUP_FOR_PATIENT_GROUP = gql`
  mutation CreateRequestGroupForPatientGroup(
    $record: CreatePatientGroupRequestGroupsInput!
  ) {
    patientGroup {
      createPatientGroupRequestGroups(record: $record) {
        ok
        error {
          code
          params
          message
        }
        result {
          taskId
        }
      }
    }
  }
`;

export const GET_REQUEST_GROUP_STATUS = gql`
  query CreateRequestGroupForPatientGroupStatus($taskId: ID!) {
    patientGroup {
      createPatientGroupRequestGroupsStatus(taskId: $taskId) {
        taskId
        taskStatus
        results {
          ok
          patientId
          requestGroupId
          error {
            code
            version
            params
            description
          }
        }
      }
    }
  }
`;
